export interface PropertyLeaseConditionsDto {
  id: string;
  possibleLeaseTerms: PossibleLeaseTerms[] | null;
  rent: number | null;
  applicationProvider: ApplicationProvider | null;
  applicationFee: number | null;
  applicationCoSignerFee: number | null;
  securityDeposit: LeaseConditionIncome | null;
  desiredLeasingDate: string | null;
  otherFees: string | null;
}

export enum ApplicationProvider {
  TALLO = 'Tallo',
  OTHER = 'Other',
}

export enum PossibleLeaseTerms {
  MONTHLY = 'Month to Month',
  ONE_MONTH = '1 Month',
  THREE_MONTHS = '3 Months',
  SIX_MONTHS = '6 Months',
  ONE_YEAR = '12 Months',
  EIGHTEEN_MONTHS = '18 Months',
  TWO_YEARS = '24 Months',
  RENT_TO_OWN = 'Rent to Own',
  OTHER = 'Other',
}

export enum LeaseConditionIncome {
  X0_5_RENT = '0.5x monthly rent',
  X1_RENT = '1x monthly rent',
  X1_5_RENT = '1.5x monthly rent',
  X2_RENT = '2x monthly rent',
  X2_5_RENT = '2.5x monthly rent',
  X3_RENT = '3x monthly rent',
  X3_5_RENT = '3.5x monthly rent',
  NO_REQUIREMENT = 'No requirement',
}
